import { Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutTwo from "../../layouts/LayoutTwo";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";

const NotFound = () => {
  let { pathname } = useLocation();

  return (
    <Fragment>
      <SEO titleTemplate="Not Found" description="404" />
      {/* <LayoutTwo> */}
      {/* breadcrumb */}
      {/* <Breadcrumb
          pages={[
            { label: "Home", path: "/" },
            { label: "404 page", path: pathname },
          ]}
        /> */}
      <div className="error-area pt-40 pb-100">
        <div className="container">
          <div className="row justify-content-center align-items-end" style={{ height: '50vh' }}>
            <div className="col-xl-7 col-lg-8 text-center">
              <div className="error">
                <h1>404</h1>
                <h2 style={{ color: "#4d897c" }}>OPPS! PAGE NOT FOUND</h2>
                <p>
                  Sorry but the page you are looking for does not exist, have
                  been removed, name changed or is temporarity unavailable.
                </p>
                {/* <form className="searchform mb-50">
                    <input
                      type="text"
                      name="search"
                      id="error_search"
                      placeholder="Search..."
                      className="searchform__input"
                    />
                    <button type="submit" className="searchform__submit">
                      <i className="fa fa-search" />
                    </button>
                  </form> */}
                {/* <Link to="/" className="error-btn">
                    Back to home page
                  </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </LayoutTwo> */}
    </Fragment>
  );
};

export default NotFound;
